
import styled from "styled-components";

export const Tags = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  a {
    margin: 0 1%;
  }
  @media only screen and (max-width: 992px) {
    flex-wrap: wrap;

    a {
      padding-top: 2%;
    }
  }
`;
export const Tag = styled.div`
  div {
    -webkit-transition-duration: 0.5s; /* Safari */
    transition-duration: 0.5s;
    color: ${props => (props.active ? "white" : "black")};
    background-color: ${props => (props.active ? "black" : "none")};
    cursor: pointer;
    :hover {
      background-color: black;
      color: white;
    }
  }
`;